import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { activeClass: { type: String, default: "tab--active" } }

  connect() {
    const params = new URLSearchParams(window.location.search)
    const step = parseInt(params.get("step")) || 0
    this.showTab(step)
  }

  select(event) {
    const index = parseInt(event.currentTarget.dataset.tabsIndex)
    this.showTab(index)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      const active = i === index
      tab.classList.toggle(this.activeClassValue, active)
      if (active) tab.scrollIntoView({ inline: "nearest", block: "nearest", behavior: "smooth" })
    })
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
